import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Testimonials.css';

const Testimonials = () => {
    const testimonials = [
        {
            name: 'Marie Leclerc',
            age: '32 ans',
            treatment: 'Blanchiment dentaire',
            rating: 5,
            text: 'Une expérience exceptionnelle ! L\'équipe est très professionnelle et le résultat dépasse mes attentes. Mon sourire n\'a jamais été aussi éclatant.',
            image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '2 semaines'
        },
        {
            name: 'Thomas Dupont',
            age: '28 ans',
            treatment: 'Implants dentaires',
            rating: 5,
            text: 'Grâce au Dr Dubois, j\'ai retrouvé confiance en moi. La pose d\'implants s\'est parfaitement déroulée, sans douleur et avec un suivi impeccable.',
            image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '1 mois'
        },
        {
            name: 'Sophie Bernard',
            age: '45 ans',
            treatment: 'Orthodontie Invisalign',
            rating: 5,
            text: 'Après 18 mois de traitement Invisalign, mes dents sont parfaitement alignées. Le suivi était régulier et les conseils toujours pertinents.',
            image: 'https://images.unsplash.com/photo-1494790108755-2616b612b436?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '3 semaines'
        },
        {
            name: 'Lucas Martin',
            age: '8 ans',
            treatment: 'Soins pédiatriques',
            rating: 5,
            text: 'Mon fils était terrifié par les dentistes. Grâce au Dr Leroy et à son approche ludique, il demande maintenant quand sera son prochain rendez-vous !',
            image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '1 semaine',
            parent: 'Témoignage des parents'
        },
        {
            name: 'Isabelle Moreau',
            age: '55 ans',
            treatment: 'Parodontologie',
            rating: 5,
            text: 'Souffrant de problèmes de gencives, j\'ai enfin trouvé une solution durable. L\'équipe a été à l\'écoute et le traitement très efficace.',
            image: 'https://images.unsplash.com/photo-1479936343636-73cdc5aae0c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '2 mois'
        },
        {
            name: 'Pierre Rousseau',
            age: '38 ans',
            treatment: 'Facettes céramique',
            rating: 5,
            text: 'Transformation incroyable ! Les facettes ont complètement changé mon sourire. Un travail d\'artiste réalisé avec une précision remarquable.',
            image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80',
            date: '3 mois'
        }
    ];

    const renderStars = (rating) => {
        return [...Array(5)].map((_, i) => (
            <i 
                key={i} 
                className={`fas fa-star ${i < rating ? 'star-filled' : 'star-empty'}`}
            ></i>
        ));
    };

    return (
        <section className="testimonials-section">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="section-header">
                            <span className="section-badge">Témoignages</span>
                            <h2 className="section-title">
                                Ce que disent nos patients
                            </h2>
                            <p className="section-subtitle">
                                Découvrez les expériences de nos patients et leur satisfaction 
                                après nos traitements personnalisés.
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row className="g-4">
                    {testimonials.map((testimonial, index) => (
                        <Col lg={4} md={6} key={index}>
                            <Card className="testimonial-card h-100">
                                <Card.Body>
                                    <div className="testimonial-header">
                                        <img 
                                            src={testimonial.image} 
                                            alt={testimonial.name}
                                            className="testimonial-avatar"
                                        />
                                        <div className="testimonial-info">
                                            <h5 className="testimonial-name">{testimonial.name}</h5>
                                            <span className="testimonial-age">{testimonial.age}</span>
                                            <div className="testimonial-rating">
                                                {renderStars(testimonial.rating)}
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="testimonial-treatment">
                                        <i className="fas fa-tooth me-2"></i>
                                        {testimonial.treatment}
                                        {testimonial.parent && (
                                            <span className="parent-note">({testimonial.parent})</span>
                                        )}
                                    </div>
                                    
                                    <p className="testimonial-text">"{testimonial.text}"</p>
                                    
                                    <div className="testimonial-footer">
                                        <span className="testimonial-date">
                                            <i className="fas fa-clock me-1"></i>
                                            Il y a {testimonial.date}
                                        </span>
                                        <div className="verified-badge">
                                            <i className="fas fa-check-circle me-1"></i>
                                            Vérifié
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Row className="mt-5">
                    <Col lg={6} className="mx-auto text-center">
                        <div className="satisfaction-stats">
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <i className="fas fa-smile"></i>
                                </div>
                                <div className="stat-content">
                                    <div className="stat-number">98%</div>
                                    <div className="stat-label">Satisfaction</div>
                                </div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <i className="fas fa-users"></i>
                                </div>
                                <div className="stat-content">
                                    <div className="stat-number">5000+</div>
                                    <div className="stat-label">Patients</div>
                                </div>
                            </div>
                            <div className="stat-item">
                                <div className="stat-icon">
                                    <i className="fas fa-award"></i>
                                </div>
                                <div className="stat-content">
                                    <div className="stat-number">15+</div>
                                    <div className="stat-label">Années</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Testimonials;